import React, { VoidFunctionComponent } from "react";
import { Tag } from "../tag/Tag";
import { CommercialOperations } from "@/models/scope/productSheet/CommercialOperations";
import Utils from "@/libs/Utils";
import { Offers } from "@/models/scope/productSheet/offer/Offers";

interface Props {
    commercialOperations: CommercialOperations[],
    isColumnDirection: boolean,
    soldBy: string,
    eligibleSoldBy: string[],
    eligibilityToPrivateSale: boolean;
    maxDisplayedPicto: number;
    stickersNumbers: number;
    offersData: Offers | null;
}

export const TagsBlock: VoidFunctionComponent<Props> = ({
    commercialOperations,
    isColumnDirection,
    eligibilityToPrivateSale,
    eligibleSoldBy,
    soldBy,
    stickersNumbers,
    maxDisplayedPicto, offersData
}) => {
    if (!commercialOperations?.length) return null;

    const isWinningOfferHasSalesPicto = (commercialOperation: CommercialOperations) => {
        const winningOfferId = offersData && offersData.items ? offersData.items[offersData.winningOfferIndex].offerId : '';
        const price = offersData?.items[offersData.winningOfferIndex]?.price;
        const originPrice = offersData?.items[offersData.winningOfferIndex]?.unitOriginPrice;
        const offerIds = Utils.getMetaInfosValueByCode("offerIds", commercialOperation.metaInfos);
        if (price && originPrice) {
            return offerIds.filter((offerId: string) => offerId == winningOfferId).length > 0 && price < originPrice;
        }
    }
    
    return (
        <div className={isColumnDirection ? "tag-block column" : "tag-block"}>
            {commercialOperations.map((operation, index) => {
                if (operation?.displayFP) {
                    // pour un produit mixte on peut avoir un picto dont le soldBy = "BUT_MKP"
                    if ((soldBy == 'BUT_MKP') || (soldBy !== 'BUT_MKP' && (soldBy == operation.soldBy))) {
                        // picto solde pour un produit mixte
                        if (operation.name !== 'SOLDES' || (operation.name == 'SOLDES' && (soldBy == 'BUT' || soldBy == 'BUT_MKP' || (soldBy == 'MKP' && isWinningOfferHasSalesPicto(operation))))) {
                            if ((maxDisplayedPicto > index) && (index < stickersNumbers)) {
                                if ((!operation.isPrivate) || (eligibilityToPrivateSale && operation.isPrivate)) {
                                    const commercialOperationBackgroundColor = Utils.getMetaInfosValueByCode("pictoColorFond", operation.metaInfos);
                                    const commercialOperationTextColor = Utils.getMetaInfosValueByCode("pictoColorText", operation.metaInfos);
                                    const commercialOperationTitle = Utils.getMetaInfosValueByCode("pictoTitle", operation.metaInfos);
                                    index++;
                                    const commercialOperationLink = Utils.renderCommercialOperationLink(operation);
                                    if (commercialOperationLink) {
                                        return (
                                            <Tag
                                                key={index}
                                                title={commercialOperationTitle}
                                                color={commercialOperationTextColor}
                                                backgroundColor={commercialOperationBackgroundColor}
                                            />
                                        );
                                    } else {
                                        return null;
                                    }
                                }
                            }
                        }
                    }
                }
            })}
        </div>
    );
};